module.exports = __webpack_public_path__ + "static/media/Logosistema.25f422f7.svg";